import React, {useContext} from "react";
import "./WorkExperience.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import {workExperiences} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function WorkExperience() {
  const {isDark} = useContext(StyleContext);
  if (workExperiences.display) {
    return (
      <section id="experience">
        <div className="experience-container" id="workExperience">
          <Fade bottom duration={900} distance="24px">
            <div className="experience-header">
              <h1 className="experience-heading">Experience</h1>
            </div>
          </Fade>
          <div className="experience-cards-div">
            {workExperiences.experience.map((card, i) => {
              return (
                <Fade bottom duration={900} distance="24px" delay={i * 120} key={`${card.company}-${card.role}`}>
                  <div className="experience-card-shell">
                    <ExperienceCard
                      isDark={isDark}
                      cardInfo={{
                        company: card.company,
                        desc: card.desc,
                        date: card.date,
                        companylogo: card.companylogo,
                        role: card.role,
                        descBullets: card.descBullets
                      }}
                    />
                  </div>
                </Fade>
              );
            })}
          </div>
        </div>
      </section>
    );
  }
  return null;
}
